// extracted by mini-css-extract-plugin
module.exports = {"conditions":"bd_fl","conditions__content":"bd_fm","conditions__footer":"bd_fn"};